import { ContentelementsModule } from '@/Foundation/ContentElements/platform';
import '@/Feature/Navigation/platform/app/bootstrapper';
import { IProductApiConfig } from '@/Foundation/ProductApi/platform';
import { ProductCatalogueModule } from '@/Feature/ProductCatalogue/platform';
import { ProductComaprisonModule } from '@/Feature/ProductComparison/platform';
import { ProductFinderModule } from '@/Feature/ProductFilterModule/platform';
import { StoreSupportModule } from '@/Feature/StoreSupport/platform';
import '@/Feature/WFFMCustomizations/platform';
import { ColorDotsComponentNgModule } from '@gn-audio/angularjs-components/color-dots';
import { FallbackSrcComponentNgModule } from '@gn-audio/angularjs-components/fallback-src';
import { JabraVideoComponentNgModule } from '@gn-audio/angularjs-components/jabra-video';
import { PriceComponentNgModule } from '@gn-audio/angularjs-components/price';
import { ProductComponentNgModule } from '@gn-audio/angularjs-components/product';
import { Product3dViewComponentNgModule } from '@gn-audio/angularjs-components/product-3d-view';
import { ProductActionComponentNgModule } from '@gn-audio/angularjs-components/product-action';
import { ProductAttributesComponentNgModule } from '@gn-audio/angularjs-components/product-attributes';
import { ProductBulletsComponentNgModule } from '@gn-audio/angularjs-components/product-bullets';
import { ProductFeaturesComponentNgModule } from '@gn-audio/angularjs-components/product-features';
import { ProductImagesComponentNgModule } from '@gn-audio/angularjs-components/product-images';
import { ProductKeySellingPointsComponentNgModule } from '@gn-audio/angularjs-components/product-key-selling-points';
import { ProductsComponentNgModule } from '@gn-audio/angularjs-components/products';
import { ScrollToComponentNgModule } from '@gn-audio/angularjs-components/scroll-to';
import { SignInComponentNgModule } from '@gn-audio/angularjs-components/sign-in';
import { SignUpComponentNgModule } from '@gn-audio/angularjs-components/sign-up';
import { SignOutComponentNgModule } from '@gn-audio/angularjs-components/sign-out';
import { SlickComponentNgModule } from '@gn-audio/angularjs-components/slick';
import { SyncModelComponentNgModule } from '@gn-audio/angularjs-components/sync-model';
import { MarketLocaleInterceptor } from './interceptors/market-locale-interceptor';
import { LocaleComponentNgModule } from '@gn-audio/angularjs-components/locale';
import { IWasThisUsefulProvider, WasThisUsefulComponentNgModule } from '@gn-audio/angularjs-components/was-this-useful';
import { NgModule } from 'angular-ts-decorators';
import 'jquery';
import 'node_modules/@gn-audio/ui/javascript/jquery.lazyloadxt.js';
import 'whatwg-fetch';
import './polyfills';
import { CoveoAnalyticsComponentNgModule } from '@gn-audio/angularjs-components/coveo-user-analytics/module';
import { CoveoAnalyticsWrapperComponent } from './coveo-analytics-wrapper/coveo-analytics-wrapper';

@NgModule({
  id: 'gn.audio.public',
  declarations: [
    CoveoAnalyticsWrapperComponent,
  ],
  imports: [
    ColorDotsComponentNgModule.name,
    FallbackSrcComponentNgModule.name,
    JabraVideoComponentNgModule.name,
    PriceComponentNgModule.name,
    Product3dViewComponentNgModule.name,
    ProductActionComponentNgModule.name,
    ProductAttributesComponentNgModule.name,
    ProductBulletsComponentNgModule.name,
    ProductComponentNgModule.name,
    ProductFeaturesComponentNgModule.name,
    ProductImagesComponentNgModule.name,
    ProductKeySellingPointsComponentNgModule.name,
    ProductsComponentNgModule.name,
    ScrollToComponentNgModule.name,
    SlickComponentNgModule.name,
    SyncModelComponentNgModule.name,
    WasThisUsefulComponentNgModule.name,
    SignInComponentNgModule.name,
    SignOutComponentNgModule.name,
    SignUpComponentNgModule.name,
    LocaleComponentNgModule.name,
    CoveoAnalyticsComponentNgModule.name,

    ContentelementsModule,
    ProductCatalogueModule,
    ProductComaprisonModule,
    ProductFinderModule,
    StoreSupportModule,
  ],
  providers: [
    MarketLocaleInterceptor,
  ],
})
export class ShellModule {
  public static async config(
    $sceProvider: ng.ISCEProvider,
    $httpProvider: ng.IHttpProvider,
    $locationProvider: ng.ILocationProvider,
    productApiConfig: IProductApiConfig,
    wasThisUsefulProvider: IWasThisUsefulProvider,
  ) {
    'ngInject';

    $sceProvider.enabled(false);
    $httpProvider.interceptors.push("MarketLocaleInterceptor");
    $locationProvider.hashPrefix('');

    wasThisUsefulProvider
      .baseUrl(productApiConfig.wasThisUsefulUrl)
      .marketLocale(productApiConfig.language)
      .siteContext(productApiConfig.siteContext);
  }
}
